//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 4/10/2024
// Version : 1
// Description : pantalla para autorizaciones de modificaciones
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//
//========================================================================/
import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Box,
  DialogContentText,
  Typography,
  DialogActions,
  TextField,
} from "@mui/material";
import moment from "moment"; // PARA LA FECHA
//email
import { logEventos } from "../../services/services";
import { grey } from "@mui/material/colors";
import { enviarmails } from "../../services/services";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import { getData, postData } from "../../services/library";

function Dialog_aut_modif(props) {
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [openSnackEditar, setOpenSnackEditar] = React.useState(false);
  const [openCrear, setOpenCrear] = React.useState(false);
  const [disabledGuardarRe, setDisabledGuardarRe] = useState(false);
  const [colorTextField, setcolorTextField] = useState();
  //   const [update, setUpdate] = useState(false);
  const [inventarioPrendas, setInventarioPrendas] = useState();
  const [talles, setTalles] = useState([]);
  const [stockPorTalles, setStockPorTalles] = useState([]);
  const [errorCantidad, setErrorCantidad] = useState(false);
  const [row, setRow] = useState(props.row);
  const [abrirConfirmacion, setAbrirConfirmacion] = useState(
    props.abrirConfirmacion
  );
  //*************************************************************************************************************************************/
  // RECHAZO MODIFICACION - (ABAJO)
  const [dialogRechazarModificacion, setDialogRechazarModificacion] =
    useState(false);
  const handleCloseDialogRechazarModificacion = () => {
    setDialogRechazarModificacion(false);
  };

  const handleClickOpenRechazar = async (row) => {
    setDialogRechazarModificacion(true);
  };

  const handleCloseRechazo = () => {
    setDialogRechazarModificacion(false);
  };

  const handleClose = () => {
    //   setAbrirConfirmacion(false);
    setAbrirConfirmacion(!abrirConfirmacion);
    // setSnack(true)
    if (props.onClose) {
      props.onClose();
    }
  };

  //************ GUARDAR AJUSTE *************************************************************************************************************************/

  const guardarAjusteStock = async (e) => {
    // logEventos(
    //   "Guardar ajuste de stock",
    //   "Stock Sucursales",
    //   "Se guardo el ajuste de stock",
    //   localStorage.getItem("user")
    // );
    //INVENTARIO
    e.preventDefault();
    await fetch(
      UrlApi +
        "/stock_inventarios/" +
        row.id_almacen_origen +
        "/" +
        row.id_articulo,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cantidad: parseInt(row.cantidad_recibida),
          usuario: localStorage.getItem("user"),
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setColorMensaje("#D4EFDF");
          setMensaje("El Ajuste de Stock se Realizo Exitosamente !");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al Realizar Ajuste de Stock");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    // TRANSACCIONES
    e.preventDefault();
    await fetch(UrlApi + "/stock_transacciones/" + row.id_transaccion, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        autorizar_modificacion: 2,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El artículo se guardó exitosamente !");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el artículo");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
// inventario por talles
        e.preventDefault();
        if (row.tiene_talles === 1) {
          for (let i = 0; i < stockPorTalles.length; i++) {
            const element = stockPorTalles[i];
            if (element.stock > 0) {
              // Verifica si el talle ya existe en inventarioPrendas
              const talleExistente = inventarioPrendas.find(
                (item) => item.talle === element.id
              );
        
              // Configuración de la solicitud
              const url = talleExistente
                ? `${UrlApi}/stock_prendas/${talleExistente.id}` // PUT si existe
                : `${UrlApi}/stock_prendas`; // POST si no existe
              const metodo = talleExistente ? "PUT" : "POST";
        
              // Calcular la cantidad para el PUT
              const nuevaCantidad = talleExistente
                ? talleExistente.cantidad - element.stock // Resta la cantidad existente con la nueva
                : element.stock;
        
              // Realiza la solicitud
              try {
                const response = await fetch(url, {
                  method: metodo,
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    almacen: row.id_almacen_origen,
                    articulo: row.id_articulo,
                    talle: element.id,
                    cantidad: element.stock, // En el PUT
                    usuario: localStorage.getItem("user"),
                  }),
                });
        
                if (response.ok) {
                  setOpenSnack(true);
                  setColorMensaje("#D4EFDF");
                  setMensaje(
                    talleExistente
                      ? "El artículo se actualizó exitosamente!"
                      : "El artículo se guardó exitosamente!"
                  );
                } else {
                  throw new Error("Error al guardar el artículo");
                }
              } catch (error) {
                console.error(error.message);
                setOpenSnack(false);
                setColorMensaje("#F1948A");
                setMensaje("Error al guardar el artículo");
              }
            }
          }
        }


    handleClose();
  };
  // console.log("stockPorTalles",stockPorTalles);
  
  const guardarRechazar = async (e) => {
    // logEventos(
    //   "Guardar rechazar artículo",
    //   "Stock Autorizar Articulos",
    //   "Se rechazo el artículo",
    //   localStorage.getItem("user")
    // );
    console.log("Estoy por guardar");
    e.preventDefault();
    await fetch(UrlApi + "/stock_transacciones/" + row.id_transaccion, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        autorizar_modificacion: 3,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          //   setUpdate(true);
          // setMensajeConfirma(true)
          setColorMensaje("#D4EFDF");
          setMensaje("El artículo se rechazó!");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al rechazar el artículo");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
    // console.log(row.id_articulo);
    handleClose();
  };
  //*******************************************************************/
  // console.log("ROW DIALOG", row);
  // console.log("ID ALMACEN ORIGEN", row.id_almacen_origen);
  // console.log("ID ALMACEN DESTINO", row.id_almacen_destino);
  // console.log("ID ARTICULO", row.id_articulo);
  // console.log("CANTIDAD NUEVA", row.cantidad_recibida);
  //**********************************************************************/
  const [usuarioCompras, setUsuarioCompras] = useState([]);

  const obtenerUsuarioCompras = () => {
    fetch(UrlApi + "/userdata/sector/4/")
      .then((data) => data.json())
      .then((data) => setUsuarioCompras(data));
  };
  useEffect(() => {
    obtenerUsuarioCompras();
  }, []);

  // const [usuarioAdmin, setUsuarioAdmin] = useState([]);

  // const obtenerUsuarioAdmin = () => {
  //   fetch(UrlApi + "/userdata/sector/5/")
  //     .then((data) => data.json())
  //     .then((data) => setUsuarioAdmin(data));
  // };
  // useEffect(() => {
  //   obtenerUsuarioAdmin();
  // }, []);

  //console.log("usuario admin",usuarioAdmin);
  //console.log("usuario compras",usuarioCompras);
  //*******************************************************************/
  const [reqExiste, setReqExiste] = useState([]);

  const obtenerRequerimientoExistente = () => {
    fetch(
      UrlApi +
        "/requerimientos_materiales/reqexiste/" +
        localStorage.getItem("sucursal") +
        "/" +
        row.id_articulo
    )
      .then((data) => data.json())
      .then((data) => setReqExiste(data));
  };

  useEffect(() => {
    obtenerRequerimientoExistente();
  }, [row]);
  //****************************************************************** */
  const [inventarioTrResta, setInventarioTrResta] = useState([]);
  //funcion para obtener sucursales
  const obtenerInventarioTrResta = () => {
    fetch(
      UrlApi +
        "/stock_inventarios/xalmart/" +
        row.id_almacen_origen +
        "/" +
        row.id_articulo
    )
      .then((data) => data.json())
      .then((data) => setInventarioTrResta(data));
  };

  useEffect(() => {
    obtenerInventarioTrResta();
  }, [row.id_almacen_origen, row.id_articulo]);

  const [inventarioConv, setInventarioConv] = useState([]);
  const obtenerInventarioConv = () => {
    fetch(
      UrlApi +
        "/stock_inventarios/xalmart/" +
        row.id_almacen_destino +
        "/" +
        row.convertible_a
    )
      .then((data) => data.json())
      .then((data) => setInventarioConv(data));
  };

  useEffect(() => {
    obtenerInventarioConv();
  }, [row.id_almacen_destino, row.convertible_a]);

  const [cantidadInventarioConv, setCantidadInventarioConv] = useState(0);

  // CALCULO DEL TOTAL FINAL
  useEffect(() => {
    setCantidadInventarioConv(
      inventarioConv[0]
        ? parseInt(inventarioConv[0].cantidad) + parseInt(row.cantidad_enviada)
        : null
    );
  }, [inventarioConv, row.cantidad_enviada, row.id_almacen_destino]);

  const [cantidadInventarioTrResta, setCantidadInventarioTrResta] = useState(0);

  // const handleCantidadInventarioTrResta = (e) => {
  //   setCantidadInventarioTrResta(e.target.value);
  // };

  // CALCULO DEL TOTAL FINAL

  useEffect(() => {
    setCantidadInventarioTrResta(
      inventarioTrResta[0] && row.cantidad_enviada
        ? parseInt(inventarioTrResta[0].cantidad) -
            parseInt(row.cantidad_enviada)
        : 0 // valor por defecto en caso de que inventarioTrResta[0] no esté disponible
    );
  }, [inventarioTrResta, row.cantidad_enviada]);

  // console.log("cantidad QUE VA A TENER EL NUEVO",cantidadInventarioConv);
  // console.log("CANT DE LO QUE QUEDA",cantidadInventarioTrResta);
  // console.log("inventarioConv",inventarioConv);
  // console.log("inventarioTrResta",inventarioTrResta);
  // console.log("cantidad enviada",row.cantidad_enviada);

  // const envioMail = async (e) => {
  //   const usuariosNotificar = [...(usuarioCompras || []), ...(usuarioAdmin || [])]; // Combinar ambos arrays
  //  // console.log("usuarios notificar",usuariosNotificar);

  //   usuariosNotificar &&
  //     usuariosNotificar.length > 0 &&
  //     usuariosNotificar.forEach((usuario) => {
  //       if (usuario.email) {
  //         if (
  //           cantidadInventarioTrResta < row.alerta_minima &&
  //           cantidadInventarioTrResta > row.valor_minimo
  //         ) {
  //           enviarmails(
  //             usuario.email,
  //             "Advertencia de Nivel de Stock",
  //             `<p>El artículo <b>${row.nombre_articulo}</b> del almacén <b>${row.nombre_almacen_origen}</b> está por debajo del punto de pedido.<br/></p>`
  //           );
  //         } else if (cantidadInventarioTrResta < row.valor_minimo) {
  //           enviarmails(
  //             usuario.email,
  //             "Alerta de Stock por Debajo del Nivel Mínimo",
  //             `<p>El artículo <b>${row.nombre_articulo}</b> del almacén <b>${row.nombre_almacen_origen}</b> está por debajo del stock mínimo.<br/></p>`
  //           );
  //         }
  //       }
  //     });
  // };

  // const envioMail = async (e) => {
  //   usuarioCompras &&
  //     usuarioCompras.length > 0 &&
  //     usuarioCompras.forEach((usuario) => {
  //       if (usuario.email) {
  //         if (
  //           cantidadInventarioTrResta < row.alerta_minima &&
  //           cantidadInventarioTrResta > row.valor_minimo
  //         ) {
  //           enviarmails(
  //             usuario.email,
  //             "Advertencia de Nivel de Stock",
  //             `<p>El artículo <b>${row.nombre_articulo}</b> del almacén <b>${row.nombre_almacen_origen}</b> está por debajo del punto de pedido.<br/></p>`
  //           );
  //         } else if (cantidadInventarioTrResta < row.valor_minimo) {
  //           enviarmails(
  //             usuario.email,
  //             "Alerta de Stock por Debajo del Nivel Mínimo",
  //             `<p>El artículo <b>${row.nombre_articulo}</b> del almacén <b>${row.nombre_almacen_origen}</b> está por debajo del stock mínimo.<br/></p>`
  //           );
  //         }
  //       }
  //     });
  // };

  // *********************************REQUERIMIENTO***************************************** //
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [uuid, setUuid] = useState(uuidv4());

  const [envioRequerimiento, setEnvioRequerimiento] = useState({
    id_movil: null,
    id_sucursal: localStorage.getItem("sucursal"),
    fecha_entrega: moment(row.fecha_transaccion).format("YYYY-MM-DD HH:mm:ss"),
    usuario_registra: localStorage.getItem("user"),
    usuario_autoriza: null,
    estado: 50, //cuando se carga el pedido se pone en estado "A autorizar"
    para_comprar: 1,
    observaciones: "",
    uuid_requerimiento: uuid,
    comentarios_internos: "Pedido Automático - Definir Cantidad",
    para_compras: 0,
    para_rrhh: 0,
    autorizado_jefe_compras: 0,
  });

  const [datosLista, setDatosLista] = useState([
    {
      material: null,
      usuario: localStorage.getItem("user"),
      cantidad: 1,
      // id_unidad_medida: row.id_unidad_medida,
      uuid_requerimiento: envioRequerimiento.uuid_requerimiento,
      id_articulo: row.id_articulo,
    },
  ]);

  useEffect(() => {
    setDatosLista([
      {
        material: null,
        usuario: localStorage.getItem("user"),
        cantidad: 1,
        // id_unidad_medida: row.id_unidad_medida,
        uuid_requerimiento: envioRequerimiento.uuid_requerimiento,
        id_articulo: row.id_articulo,
      },
    ]);
    setEnvioRequerimiento({
      id_movil: null,
      id_sucursal: localStorage.getItem("sucursal"),
      fecha_entrega: moment(row.fecha_transaccion).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      usuario_registra: localStorage.getItem("user"),
      usuario_autoriza: null,
      estado: 50, //cuando se carga el pedido se pone en estado "A autorizar"
      para_comprar: 1,
      observaciones: "",
      uuid_requerimiento: uuid,
      comentarios_internos: "Pedido Automático - Definir Cantidad",
      para_compras: 0,
      para_rrhh: 0,
      autorizado_jefe_compras: 0,
    });
  }, [row]);

  const guardarListaMateriales = (e) => {
    postData(
      e,
      "/lista_materiales",
      {
        datosLista,
      },
      setNotificacion
    );
  };
  // console.log(row);

  // ************************************************************************** //
  const guardarConversion = async (e) => {
    logEventos(
      "Guardar conversión",
      "Stock Sucursales",
      "Se guardo conversión",
      localStorage.getItem("user")
    );
    e.preventDefault();

    // console.log("Valor inicial de inventarioTrResta POST:", inventarioTrResta);

    if (inventarioConv.length === 0) {
      await fetch(UrlApi + "/stock_inventarios", {
        // PUT SI YA EXISTE / POST SI ES NUEVO
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_articulo: row.convertible_a,
          cantidad: row.cantidad_enviada,
          id_almacen: row.id_almacen_destino,
          usuario: localStorage.getItem("user"),
        }),
      })
        .then((res) => {
          if (!res.err) {
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El artículo se guardó exitosamente !");
          } else {
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      // Verificar cantidad después de la primera operación
      // console.log("Cantidad después del PUT CANT INV:", cantidadInventarioTrResta);
      await fetch(
        UrlApi +
          "/stock_inventarios/" +
          row.id_almacen_origen +
          "/" +
          row.id_articulo,
        {
          // PUT SI YA EXISTE / POST SI ES NUEVO
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cantidad: cantidadInventarioTrResta,
            usuario: localStorage.getItem("user"),
          }),
        }
      )
        .then((res) => {
          if (!res.err) {
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El artículo se guardó exitosamente !");
          } else {
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    } else {
      // console.log("Cantidad después del PUT CANT INV CONV:", cantidadInventarioTrResta);

      await fetch(
        UrlApi +
          "/stock_inventarios/" +
          row.id_almacen_destino +
          "/" +
          row.convertible_a,
        {
          // PUT SI YA EXISTE / POST SI ES NUEVO
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cantidad: cantidadInventarioConv,
            usuario: localStorage.getItem("user"),
          }),
        }
      )
        .then((res) => {
          if (!res.err) {
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El artículo se guardó exitosamente !");
          } else {
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      // console.log("Cantidad después del PUT 2 CANT INV:", cantidadInventarioTrResta);

      await fetch(
        UrlApi +
          "/stock_inventarios/" +
          row.id_almacen_origen +
          "/" +
          row.id_articulo,
        {
          // PUT SI YA EXISTE / POST SI ES NUEVO
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cantidad: cantidadInventarioTrResta,
            usuario: localStorage.getItem("user"),
          }),
        }
      )
        .then((res) => {
          if (!res.err) {
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El artículo se guardó exitosamente !");
          } else {
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
    await fetch(UrlApi + "/stock_transacciones/" + row.id_transaccion, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        autorizar_modificacion: 2,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          //   setUpdate(true);
          // setMensajeConfirma(true)
          setColorMensaje("#D4EFDF");
          setMensaje("El artículo se autorizó!");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al autorizar el artículo");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
    if (
      cantidadInventarioTrResta < row.alerta_minima &&
      cantidadInventarioTrResta >= row.valor_minimo
    ) {
      //  console.log("ADVERTENCIA AMARILLA");
      if (row.pedido_automatico === 1 && reqExiste.length === 0) {
        //  console.log("ES AUTOMATICO AMARILLO");
        postData(
          e,
          "/requerimientos_materiales",
          {
            id_sucursal: envioRequerimiento.id_sucursal,
            id_movil: envioRequerimiento.id_movil,
            estado: 50, //cuando se carga el pedido se pone en estado "Pendiente autorizacion"
            para_comprar: envioRequerimiento.para_comprar,
            para_compras: envioRequerimiento.para_compras,
            para_rrhh: envioRequerimiento.para_rrhh,
            fecha_entrega: envioRequerimiento.fecha_entrega,
            usuario_registra: envioRequerimiento.usuario_registra,
            usuario_autoriza: envioRequerimiento.username,
            observaciones: envioRequerimiento.observaciones,
            uuid_requerimiento: uuid,
            comentarios_internos: envioRequerimiento.comentarios_internos,
            autorizado_jefe_compras: 0,
          },
          setNotificacion,
          guardarListaMateriales(e)
        )
          .then((response) => {
            console.log("Respuesta de postData en guardarCabecera:", response);
          })
          .catch((error) => {
            console.error("Error en postData en guardarCabecera:", error);
          });
      }
    } else if (cantidadInventarioTrResta < row.valor_minimo) {
      // console.log("ADVERTENCIA ROJA");
      if (row.pedido_automatico === 1 && reqExiste.length === 0) {
        //   console.log("ES AUTOMATICO ROJO");
        postData(
          e,
          "/requerimientos_materiales",
          {
            id_sucursal: envioRequerimiento.id_sucursal,
            id_movil: envioRequerimiento.id_movil,
            estado: 50, //cuando se carga el pedido se pone en estado "Pendiente autorizacion"
            para_comprar: envioRequerimiento.para_comprar,
            para_compras: envioRequerimiento.para_compras,
            para_rrhh: envioRequerimiento.para_rrhh,
            fecha_entrega: envioRequerimiento.fecha_entrega,
            usuario_registra: envioRequerimiento.usuario_registra,
            usuario_autoriza: envioRequerimiento.username,
            observaciones: envioRequerimiento.observaciones,
            uuid_requerimiento: uuid,
            comentarios_internos: envioRequerimiento.comentarios_internos,
            autorizado_jefe_compras: 0,
          },
          setNotificacion,
          guardarListaMateriales(e)
        )
          .then((response) => {
            console.log("Respuesta de postData en guardarCabecera:", response);
          })
          .catch((error) => {
            console.error("Error en postData en guardarCabecera:", error);
          });
      }
    }
    // if (row.enviamail === 1) {
    //   envioMail();
    // }
    handleClose();
  };

  useEffect(() => {
    if (cantidadInventarioTrResta < 0) {
      setDisabledGuardarRe(true);
      setcolorTextField("error");
    } else {
      setDisabledGuardarRe(false);
      setcolorTextField("primary");
    }
  }, [cantidadInventarioTrResta, row.cantidad_enviada]);

  //TALLES

  useEffect(() => {
    if (row.id_accion === 201 && row.tiene_talles === 1) {
      console.log("mostrar inventario de talles");
    }
  }, []);

  const obtenerTalles = () => {
    getData(
      "/stock_prendas_talles/tallesxprendaactivo/" + row.tipo_prenda,
      setTalles
    );
  };

  useEffect(() => {
    if (row.id_accion === 201 && row.tiene_talles === 1) {
      obtenerTalles();
    }
  }, [row]);

  useEffect(() => {
    if (talles.length > 0 && inventarioPrendas.length > 0) {
      const stockInicial = talles.map((talle) => {
        const inventario = inventarioPrendas.find((item) => item.talle === talle.id);
        return {
          id: talle.id,
          stock: inventario ? inventario.cantidad : 0,
        };
      });
      setStockPorTalles(stockInicial);
    }
  }, [talles, inventarioPrendas]);
  

  // console.log("stock", inventarioPrendas);
// Validar la suma de los talles
useEffect(() => {
  const totalAsignado = stockPorTalles.reduce((sum, item) => sum + item.stock, 0);

  // Valida si la suma coincide con cantidad_recibida
  if (totalAsignado === parseInt(row.cantidad_recibida)) {
    setErrorCantidad(false); // No hay error
  } else {
    setErrorCantidad(true); // Error
  }
}, [stockPorTalles, row.cantidad_recibida]);


  const handleStockChange = (id, newStock) => {
    const stockValue = Number(newStock);
  
    if (isNaN(stockValue) || stockValue < 0) return; // Evitar valores inválidos
  
    // Actualizar el stock ingresado para el talle específico
    setStockPorTalles((prevStock) => {
      const updatedStock = prevStock.map((item) =>
        item.id === id ? { ...item, stock: stockValue } : item
      );
  
      // Verificar si la suma es igual al cantidad_recibida
      const totalAsignado = updatedStock.reduce((sum, item) => sum + item.stock, 0);
      if (totalAsignado === parseInt(row.cantidad_recibida)) {
        setErrorCantidad(true); // Error si no coincide
      }
  
      return updatedStock;
    });
  };
  
  

  // useEffect(() => {
  //   if (datosArt.tiene_talles===1 && consumo.cantidad_enviada> 0) {
  //     const totalAsignado = stockPorTalles.reduce((sum, item) => sum + item.stock, 0);

  //     // Valida que la suma no exceda datosArt.cantidad_recibida
  //     if (totalAsignado > consumo.cantidad_enviada || totalAsignado < consumo.cantidad_enviada) {
  //       setErrorCantidad(true);
  //     } else {
  //       setErrorCantidad(false);
  //     }
  //   }
  // }, [stockPorTalles, consumo.cantidad_enviada]);

  useEffect(() => {
    if (row) {
      if (row.tiene_talles === 1) {
        getData(
          `/stock_prendas/detalle/${row.id_almacen_origen}/${row.id_articulo}`,
          setInventarioPrendas
        );
      }
    }
  }, [row]);

  return (
    <div>
      {/*------------ DIALOG APROBAR AJUSTE---------------*/}
      {row.tipo_transaccion === "Ajuste" ? (
        <Dialog
          open={abrirConfirmacion}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
        >
          <Box backgroundColor={"#1F618D"} mt={1}>
            <DialogTitle>
              <Typography variant="h6" align="center" color="#ffffff">
                Confirmar Ajuste
              </Typography>
            </DialogTitle>
          </Box>
          <form onSubmit={guardarAjusteStock}>
            <Box
              border={0.5}
              borderColor={grey[300]}
              backgroundColor="#F4F6F6"
              p={2}
              py={2}
              mt={1}
            >
              <DialogContent>
                <Grid container spacing={1}>
                  <Grid item xs={
                    // row.tiene_talles === 1                  
                    //   ? 6
                    //s   : 12
                    12
                  }>

                <DialogContentText textAlign={"center"}>
                  ¿Desea Autorizar el Ajuste?
                </DialogContentText>
                  </Grid>

                {/* Talles */}
                <Grid 
                  item 
                  xs={12} 
                  mb={1} 
                  display="flex" 
                  justifyContent="center" 
                  alignItems="center"
                >
                  {row?.tiene_talles === 1 &&
                    row.cantidad_recibida !== null &&
                    row.cantidad_recibida > 0 && (
                      <Box
                      alignContent={"center"}
                        maxWidth={250}
                        border={1}
                        borderColor={grey[400]}
                        borderRadius={2}
                        p={1}
                        backgroundColor="#FFFFFF"
                      >
                        <Typography
                          variant="h6"
                          align="center"
                          // gutterBottom
                        >
                          Stock Por Talles
                        </Typography>
                        <Box textAlign="center">
                          <Typography variant="body1">
                            Total asignado:{" "}
                            {stockPorTalles.reduce(
                              (sum, item) => sum + item.stock,
                              0
                            )}{" "}
                            / {row.cantidad_recibida}
                          </Typography>
                        </Box>
                        <Box
                          // border={1}
                          // borderColor={grey[300]}
                          borderRadius={2}
                          p={1}
                          backgroundColor="#FFFFFF"
                          maxHeight="150px"
                          overflow="auto"
                        >
                          <Grid container spacing={1}>
                            {talles.map((talle) => (
                              <Grid item xs={12} key={talle.id}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  // p={1}
                                  border={1}
                                  borderColor={grey[300]}
                                  borderRadius={2}
                                  // backgroundColor="#F9FAFB"
                                >
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                    display={"flex"}
                                    alignItems={"center"}
                                  >
                                    {talle.talle}
                                  </Typography>
                                  <TextField
                                    type="number"
                                    variant="outlined"
                                    size="small"
                                    value={
                                      stockPorTalles.find(
                                        (item) => item.id === talle.id
                                      )?.stock || 0
                                    }
                                    onChange={(e) =>
                                      handleStockChange(
                                        talle.id,
                                        e.target.value
                                      )
                                    }
                                    InputProps={{
                                      inputProps: { min: 0 },
                                    }}
                                    sx={{
                                      maxWidth: "100px",
                                      borderColor: errorCantidad
                                        ? "red"
                                        : "inherit", // Borde rojo en caso de error
                                      "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                          borderColor: errorCantidad
                                            ? "red"
                                            : "", // Borde rojo cuando esté enfocado y haya error
                                        },
                                      },
                                    }}
                                  />
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </Box>
                    )}
                </Grid>
                </Grid>
                
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    style={{ backgroundColor: "#1976D2", color: "#ffffff" }}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleClickOpenRechazar}
                    style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                  >
                    Rechazar
                  </Button>
                  <Button
                    // style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={row?.tiene_talles === 1?errorCantidad:false}
                  >
                    Autorizar
                  </Button>
                </Grid>
              </DialogActions>
            </Box>
          </form>
        </Dialog>
      ) : null}

      {/* ------ DIALOG RECHAZAR AJUSTE ------ */}
      {row.tipo_transaccion === "Ajuste" ? (
        <Dialog
          open={dialogRechazarModificacion}
          onClose={handleCloseDialogRechazarModificacion}
        >
          <form onSubmit={guardarRechazar}>
            <Box backgroundColor={"#1F618D"} mt={1}>
              <DialogTitle>
                <Typography variant="h6" align="center" color="#ffffff">
                  Rechazar Ajuste
                </Typography>
              </DialogTitle>
            </Box>
            <Box
              border={0.5}
              borderColor={grey[300]}
              backgroundColor="#F4F6F6"
              p={2}
              py={2}
              mt={1}
            >
              <DialogContent>
                <DialogContentText textAlign={"center"}>
                  ¿Desea Rechazar el Ajuste?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    onClick={handleCloseRechazo}
                    style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                  >
                    Volver
                  </Button>
                  <Button
                    style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Confirmar
                  </Button>
                </Grid>
              </DialogActions>
            </Box>
          </form>
        </Dialog>
      ) : null}

      {/*------------ DIALOG APROBAR CONVERSION ---------------*/}
      {row.tipo_transaccion === "Conversion" ? (
        <Dialog
          open={abrirConfirmacion}
          onClose={handleClose}
          maxWidth="xs"
          fullWidth
        >
          <Box backgroundColor={"#1F618D"} mt={1}>
            <DialogTitle>
              <Typography variant="h6" align="center" color="#ffffff">
                Confirmar Conversión
              </Typography>
            </DialogTitle>
          </Box>
          <form onSubmit={guardarConversion}>
            <Box
              border={0.5}
              borderColor={grey[300]}
              backgroundColor="#F4F6F6"
              p={2}
              py={2}
              mt={1}
            >
              <DialogContent>
                <DialogContentText textAlign={"center"}>
                  ¿Desea Autorizar la Conversión?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    style={{ backgroundColor: "#1976D2", color: "#ffffff" }}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleClickOpenRechazar}
                    style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                  >
                    Rechazar
                  </Button>
                  <Button
                    style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Autorizar
                  </Button>
                </Grid>
              </DialogActions>
            </Box>
          </form>
        </Dialog>
      ) : null}

      {/* ------ DIALOG RECHAZAR CONVERSION ------ */}
      {row.tipo_transaccion === "Conversion" ? (
        <Dialog
          open={dialogRechazarModificacion}
          onClose={handleCloseDialogRechazarModificacion}
        >
          <form onSubmit={guardarRechazar}>
            <Box backgroundColor={"#1F618D"} mt={1}>
              <DialogTitle>
                <Typography variant="h6" align="center" color="#ffffff">
                  Rechazar Conversión
                </Typography>
              </DialogTitle>
            </Box>
            <Box
              border={0.5}
              borderColor={grey[300]}
              backgroundColor="#F4F6F6"
              p={2}
              py={2}
              mt={1}
            >
              <DialogContent>
                <DialogContentText textAlign={"center"}>
                  ¿Desea Rechazar la Conversión?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    onClick={handleCloseRechazo}
                    style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                  >
                    Volver
                  </Button>
                  <Button
                    style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Confirmar
                  </Button>
                </Grid>
              </DialogActions>
            </Box>
          </form>
        </Dialog>
      ) : null}
    </div>
  );
}

export default Dialog_aut_modif;
